/**
 * Centralized query keys for React Query
 * This ensures consistency across the application and makes invalidation easier
 */

export const queryKeys = {
  // Properties
  properties: ['properties'] as const,
  property: (id: number | string) => ['property', id] as const,
  propertyList: ['property-list'] as const,
  
  // STATEC Properties
  statecProperties: ['statec-properties'] as const,
  statecProperty: (id: number | string) => ['statec-property', id] as const,
  
  // CTIE
  ctieFormStatus: ['ctie-form-status'] as const,
  
  // STATEC Submissions
  statecGlobalStats: ['statec-global-stats'] as const,
  statecSubmissionsDashboard: ['statec-submissions-dashboard'] as const,
  pendingSubmissions: (filters?: object) => ['pending-submissions', filters] as const,
  submissionHistory: (id: string) => ['submission-history', id] as const,
  statecSkipReasons: ['statec-skip-reasons'] as const,
  submittedRegistrations: ['submitted-registrations'] as const,
  registrationsReady: (propertyId?: number, limit?: number) => ['registrations-ready', propertyId, limit] as const,
  
  // Bookings
  bookings: (filters?: object) => ['bookings', filters] as const,
  bookingStats: ['booking-stats'] as const,
  bookingRegistrations: (id: number | null) => ['booking-registrations', id] as const,
  
  // Messages
  conversations: (filters?: object) => ['conversations', filters] as const,
  conversationMessages: (bookingId: number | null) => ['conversation-messages', bookingId] as const,
  aiSuggestions: (bookingId: number | null) => ['ai-suggestions', bookingId] as const,
  responseTemplates: (intent?: string, language?: string) => ['response-templates', intent, language] as const,
  messageStats: ['message-stats'] as const,
  
  // Dashboard
  dashboardStats: ['dashboard-stats'] as const,

  // Analytics
  analyticsRevenue: (dateRange?: object) => ['analytics-revenue', dateRange] as const,
  analyticsOccupancy: (propertyId?: number) => ['analytics-occupancy', propertyId] as const,
  analyticsSources: ['analytics-sources'] as const,
  analyticsTrends: ['analytics-trends'] as const,
  analyticsPropertyPerformance: ['analytics-property-performance'] as const,
  analyticsMessages: (dateRange?: object) => ['analytics-messages', dateRange] as const,

  // User
  userActivity: ['user-activity'] as const,
  
  // Admin
  adminCheck: ['admin-check'] as const,

  // Escalations
  escalationMonitor: (filters?: object) => ['escalation-monitor', filters] as const,
  escalations: ['escalations'] as const,

  // Knowledge
  knowledgeReviewQueue: (filters?: object) => ['knowledge-review-queue', filters] as const,
  propertyKnowledge: (filters?: object) => ['property-knowledge', filters] as const,

  // Notifications
  notifications: (limit?: number) => ['notifications', limit] as const,
  notificationsUnreadCount: ['notifications-unread-count'] as const,
} as const;
